(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npGridSetting', ['$document', function ($document) {
        return {
            restrict: 'E',
            controller: ['$scope', 'broadcastService', 'configService', controller],
            scope: {
                gridSettingKey: '@'
            },
            templateUrl: paths.GridSettingView,
            replace: true,
            link: function (scope, element, attr) {
                scope.showGridSettingContextMenu = false;
                $document.bind('click', function (event) {
                    var isClickedElementChildOfPopup = element
                      .find(event.target)
                      .length > 0;

                    if (isClickedElementChildOfPopup)
                        return;
                    scope.showGridSettingContextMenu = false;
                    scope.$apply();
                });
            }
        };
    }]);

    function controller($scope, broadcastService, configService) {
        $scope.enabledProcessModule = configService.getBool(HandbookConfiguration.EnableProcess);

        $scope.translation = globalResources;
        $scope.gridSettingKeys = gridSettingKeys;
        $scope.internetPublishOption = configService.getBool(HandbookConfiguration.InternetPublishOption);
        $scope.publishedVersion = configService.getBool(HandbookConfiguration.PublishedVersion);

        getGridSetting($scope.gridSettingKey);
        getColumnsDefinition($scope.gridSettingKey);
        $scope.optionalColumns = angular.copy(optionalColumnsDenifinition);

        if ($scope.publishedVersion) {
            delete $scope.optionalColumns['approver']; 
            delete $scope.optionalColumns['responsible']; 
            delete $scope.optionalColumns['readingReceiptDtmConfirmed']; 
            delete $scope.optionalColumns['readingReceipt']; 
        }

        $scope.updateGrid = function ($event) {
            setGridSetting($scope.gridSettingKey, $scope.optionalColumns);
            $scope.showGridSettingContextMenu = !$scope.showGridSettingContextMenu;

            getColumnsDefinition($scope.gridSettingKey);
            broadcastService(broadcastType.gridSettingTarget, commonColumnsDefinition, $scope.gridSettingKey);
        };

        $scope.$on(broadcastType.toggleGridSettingTarget, function (e, target) {
            $scope.showGridSettingContextMenu = true;
        });


        $scope.showPopup = function () {
            $scope.showGridSettingContextMenu = !$scope.showGridSettingContextMenu;
			if ($scope.showGridSettingContextMenu) {
				getGridSetting($scope.gridSettingKey);
				getColumnsDefinition($scope.gridSettingKey);
                $scope.optionalColumns = angular.copy(optionalColumnsDenifinition);
                if ($scope.publishedVersion) {
                    delete $scope.optionalColumns['approver'];
                    delete $scope.optionalColumns['responsible'];
                    delete $scope.optionalColumns['readingReceiptDtmConfirmed'];
                    delete $scope.optionalColumns['readingReceipt'];
                }
            }
        };

        $scope.checkAll = function () {
            setValueCheck(true);
        };

        $scope.uncheckAll = function () {
            setValueCheck(false);
        };

        function setValueCheck(value) {
            Object.keys($scope.optionalColumns).forEach(property => {
                $scope.optionalColumns[property] = value;
            });
        }
    }

})();